import { AxiosPromise } from 'axios'
import { createTemplatesClient } from './createTemplatesClient'
import { getTemplates, putTemplate, deleteTemplate, createPackFromTemplate } from './methods'
import { TemplatesClient as BaseTemplateClient, TemplatesClientOptions } from './types'

export default function TemplatesClient(options?: TemplatesClientOptions): UserClient {
  const commonOptions = {}

  return createTemplatesClient({
    ...commonOptions,
    ...options,
    methods: {
      deleteTemplate,
      getTemplates,
      putTemplate,
      createPackFromTemplate,
    },
  })
}

export type UserClient = BaseTemplateClient & {
  readonly getTemplates: () => AxiosPromise;
  readonly putTemplate: (id: string, data: any) => AxiosPromise;
  readonly deleteTemplate: (id: string) => AxiosPromise;
  readonly createPackFromTemplate: (id: string) => AxiosPromise;
}
